import React from 'react';
import styled from 'styled-components';
import { getColor } from 'common/constants/_colors';

const Edge = styled.div`
  height: 1.82rem;
  width: 1.73rem;
  transform: skewX(${({ isDown }) => (isDown ? '-' : '')}35deg);
  border-right: 3px solid ${getColor('botticelli')};
`;

const PipelineArrow = props => {
  return (
    <div {...props}>
      <Edge />
      <Edge isDown />
    </div>
  );
};

export default PipelineArrow;
